import { render } from "./TabModalitaPagamento.vue?vue&type=template&id=657be4db"
import script from "./TabModalitaPagamento.vue?vue&type=script&lang=js"
export * from "./TabModalitaPagamento.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__